
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/noleggio-lungo-termine-marchi",
      function () {
        return require("private-next-pages/noleggio-lungo-termine-marchi.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/noleggio-lungo-termine-marchi"])
      });
    }
  